import { computed, getCurrentInstance } from "vue";
import { g as getCurrentApp } from "../services/current-app-832a37a5.mjs";
const useAppContext = () => {
  return computed(() => {
    var _a, _b;
    return ((_a = getCurrentApp()) == null ? void 0 : _a._context) || ((_b = getCurrentInstance()) == null ? void 0 : _b.appContext);
  });
};
export {
  useAppContext as u
};
//# sourceMappingURL=useAppContext-4f7613f2.mjs.map
